import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

class BeneficiarioPoliza extends React.Component {
	render() {
		let imgBeneficiario;
		let grupo = this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05";

		switch (this.props.poliza.generales.cveRamo) {
		case "A":
			imgBeneficiario = require("../img/circle-beneficiario.svg");
			break;
		case "G":
			imgBeneficiario = require("../img/circle-beneficiario.svg");
			break;
		case "D":
			imgBeneficiario = require("../img/circle-beneficiario.svg");
			break;
		case "V":
			imgBeneficiario = require("../img/circle-beneficiario.svg");
			break;
		}
        
		return <div className=" mt-34 card">
			<i><img src={ imgBeneficiario } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Beneficiario</span>
			<div className="row">
				<div className="col-xs-12">
					<ul className="list-divider mt-25">
						{ this.props.poliza.beneficiario && !grupo && this.props.poliza.beneficiario.map((item, i) =>
							<li className="clearfix" key={i}>
								<div className="pull-left">
									<p><b>Nombre</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="nombreBeneficiario">{item.nombres} {item.apellidoPaterno} {item.apellidoMaterno}</p>
									</div>
								</div>
							</li>
						)}
						{ this.props.poliza.beneficiariosReferencia && grupo && this.props.poliza.beneficiariosReferencia.map((item, i) =>
							<li className="clearfix" key={i}>
								<div className="pull-left">
									<p><b>Nombre</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="nombreBeneficiario">{item.descripcionBeneficiario}</p>
									</div>
								</div>
							</li>
						)}
					</ul>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState)(BeneficiarioPoliza); 


// WEBPACK FOOTER //
// ./src/home/beneficiario.cmpt.js